import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://eokkdrlyfdndcvsvhgsa.supabase.co";
const supabaseKey = "sb_publishable_kSVouvZavJ-8qlGxRiGu2A_VU7PpVb7"; // publishable key
export const supabase = createClient(supabaseUrl, supabaseKey);
